import { useTranslation } from "react-i18next";
import {
  ListIcon,
  CoffeeIcon,
  UsersIcon,
  BusinessIcon,
  OtherIcon,
  HeartIcon,
} from "@/shared/icons";
import { PersonGroup } from "@/services/api/entities/person/types";
import type { MenuItem } from "../types";
import type { Person } from "@/services/api";

export const getSideMenuItems = (
  setFilter: (filter: Person["group"] | null) => void,
): MenuItem[] => {
  const { t } = useTranslation();

  return [
    {
      key: 1,
      icon: <ListIcon />,
      label: t("contactsPage.groups.all"),
      onClick: () => setFilter(null),
    },
    {
      key: 2,
      icon: <HeartIcon />,
      label: t("contactsPage.groups.family"),
      onClick: () => setFilter(PersonGroup.FAMILY),
    },
    {
      key: 3,
      icon: <CoffeeIcon />,
      label: t("contactsPage.groups.friends"),
      onClick: () => setFilter(PersonGroup.FRIENDS),
    },
    {
      key: 4,
      icon: <UsersIcon />,
      label: t("contactsPage.groups.colleagues"),
      onClick: () => setFilter(PersonGroup.COLLEAGUES),
    },
    {
      key: 5,
      icon: <BusinessIcon />,
      label: t("contactsPage.groups.business"),
      onClick: () => setFilter(PersonGroup.BUSINESS),
    },
    {
      key: 6,
      icon: <OtherIcon />,
      label: t("contactsPage.groups.other"),
      onClick: () => setFilter(PersonGroup.OTHER),
    },
  ];
};
